import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AccordionTopic from './AccordionTopic';

import { TOPIC, ARTICLE_LIST } from '../constants/PropTypesShapes';

class AccordionTopicGroup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTopic: props.activeTopic || {},
    };
    this.onToggle = this.onToggle.bind(this);
  }

  onToggle(topic, expanded) {
    this.setState({
      activeTopic: expanded ? topic : {},
    });
    if (expanded) {
      // call set-context
      this.props.callSetContextForExp(topic);
    }
  }

  renderAccordians() {
    const parentTopic = {
      id: this.props.topics.articleId,
      articleTitle: this.props.topics.articleTitle,
    };
    const { isL3TopicClicked, SelectedL1TopicDetails } = this.props;
    return this.props.topics.articleList.map((topic) => {
      // adding subTopicId for L3Topic expansion
      // adding topicId for L2 Topic expansion
      const activeTopic = this.state.activeTopic || {};
      const expanded =
        activeTopic.id === topic.id || activeTopic.subTopicId === topic.id || activeTopic.topicId === topic.id;
      return (
        <section key={topic.id}>
          <AccordionTopic
            topic={topic}
            onToggle={this.onToggle}
            expanded={expanded}
            parent={parentTopic}
            isL3TopicClicked={isL3TopicClicked}
            SelectedL1TopicDetails={SelectedL1TopicDetails}
          />
        </section>
      );
    });
  }

  render() {
    return <div className="topic-accordion-group">{this.renderAccordians()}</div>;
  }
}

AccordionTopicGroup.propTypes = {
  activeTopic: PropTypes.shape(TOPIC),
  topics: PropTypes.shape(ARTICLE_LIST).isRequired,
  isL3TopicClicked: PropTypes.bool,
  SelectedL1TopicDetails: PropTypes.shape(TOPIC).isRequired,
  callSetContextForExp: PropTypes.func,
};

AccordionTopicGroup.defaultProps = {
  activeTopic: {},
  isL3TopicClicked: false,
};

export default AccordionTopicGroup;
